import TablaYounet from './Element_Inst/TablaYounet';


const Instalaciones =()=>{

    const headCellsColumn = [
        { id: 'Nombres', numeric: false, disablePadding: false, label: 'NOMBRES', show:true, fixed:false, width:350, num:0, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'idForMikrotik', numeric: false, disablePadding: false, label: 'ID MK', show:true, fixed:false, width:150, num:1, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Status', numeric: false, disablePadding: false, label: 'STATUS', show:true, fixed:false, width:150, num:2, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Instalacion', numeric: false, disablePadding: false, label: 'INSTALACION', show:true, fixed:false, width:150, num:3, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Valor', numeric: true, disablePadding: false, label: 'VALOR', show:true, fixed:false, width:150, num:4, align:'left', fontSize:'16px', bolder:false, type:'number' },
        { id: 'Registro', numeric: false, disablePadding: false, label: 'REGISTRO', show:true, fixed:false, width:250, num:5, align:'left', fontSize:'16px', bolder:false, type:'date' },
    ];

    const variablesObject = {
        title:'INSTALACIONES',
        nameLocalStorage:'headersInstServYounet',
        api:'/api/Instalaciones',
        label:'INSTALACION',
        apiMultiples:'/api/Multiples/Instalaciones',
        isRowDown:true,
        rowDown:'Eventos',
        rowDownOk:'PAGAR',
        sumWidth:1390
    };

    return (
        <TablaYounet
            headCellsColumn={headCellsColumn}
            variablesObject={variablesObject}
        />
    )
}

export default Instalaciones;